import React from 'react';
import { useSelector } from 'react-redux';
import './leaderboard.css';
import { useMobileAppBrowserBackGuard } from '../../utils/useMobileAppBrowserBack';

function Leaderboard() {
  const { data: themeData } = useSelector((state) => state.theme);
  useMobileAppBrowserBackGuard();

  const btnBgColor =
    themeData?.button_background_color || themeData?.button_backgroundcolor;
  const btnTextColor =
    themeData?.button_text_color || themeData?.button_color;

  const cardStyle = {
    ...(btnBgColor && { backgroundColor: btnBgColor }),
  };

  const textStyle = {
    ...(btnTextColor && { color: btnTextColor }),
  };

  return (
    <div className="lb-page">
      <div className="lb-inner lb-inner--centered">
        <div className="lb-end-card" style={cardStyle}>
          <p className="lb-end-text" style={textStyle}>
            You made it to the end! Now flood the chat with your reactions,
            memes, and questionable confidence{' '}
            <span className="lb-dance-emoji" aria-hidden="true">💃🕺</span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Leaderboard;
